import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";

type ConfirmationDialogProps = {
  open: boolean;
  onClose: (returnValue: boolean) => void;
  title: string;
  text: string;
  requireConfirmInput?: boolean;
  confirmText?: string;
};

function ConfirmationDialog({
  open,
  onClose,
  title,
  text,
  requireConfirmInput,
  confirmText,
}: ConfirmationDialogProps) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  return (
    <Dialog maxWidth="md" open={open} onClose={onClose}>
      <DialogTitle>
        <Grid container>
          <Grid item xs={10}>
            <Typography sx={{ pt: 1 }}>{title}</Typography>
          </Grid>
          <Grid item xs={2}>
            <IconButton
              data-cy="closeButton"
              sx={{ float: "right" }}
              onClick={() => onClose(false)}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography>
            <strong>{text}</strong>
          </Typography>
        </DialogContentText>
        {requireConfirmInput && (
          <>
            <Typography sx={{ mt: 2, mb: 2 }}>
              {t("projects.delete-confirmation-text")} &nbsp;
              <strong>{confirmText}</strong>
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder={confirmText}
            />
          </>
        )}
        <Box sx={{ pt: 2, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ borderRadius: "25px" }}
            onClick={() => {
              setInputValue("");
              onClose(false);
            }}
          >
            {t("projects.cancel")}
          </Button>
          <Button
            variant="contained"
            sx={{ borderRadius: "25px", ml: 2 }}
            color="error"
            onClick={() => {
              setInputValue("");
              onClose(true);
            }}
            disabled={requireConfirmInput && inputValue !== confirmText}
          >
            {t("projects.confirm")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

ConfirmationDialog.defaultProps = {
  confirmText: "",
  requireConfirmInput: false,
};

export default ConfirmationDialog;
